import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import RouteTracker from './components/RouteTracker';
import { Toaster } from './components/ui/toaster';
import Home from './pages/Home';
import Photos from './pages/Photos';
import Reservation from './pages/Reservation';
import Contact from './pages/Contact';
import GuestBook from './pages/GuestBook';
import IleDeRe from './pages/IleDeRe';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

// Pages SEO
import LesPortesEnRe from './pages/LesPortesEnRe';
import PlagesIleDeRe from './pages/PlagesIleDeRe';
import ActivitesIleDeRe from './pages/ActivitesIleDeRe';
import LocationVillaLuxe from './pages/LocationVillaLuxe';
import VacancesFamille from './pages/VacancesFamille';
import GolfIleDeRe from './pages/GolfIleDeRe';
import QueFaireIleDeRe from './pages/QueFaireIleDeRe';
import WeekendIleDeRe from './pages/WeekendIleDeRe';
import MoyenneSaison from './pages/MoyenneSaison';
import SeminaireIleDeRe from './pages/SeminaireIleDeRe';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
        <RouteTracker />
        <Routes>
          {/* Admin routes (without navbar/footer) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          
          {/* Public routes (with navbar/footer) */}
          <Route path="/*" element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/photos" element={<Photos />} />
                <Route path="/reservation" element={<Reservation />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/livre-dor" element={<GuestBook />} />
                <Route path="/ile-de-re" element={<IleDeRe />} />
                
                {/* Pages SEO */}
                <Route path="/les-portes-en-re" element={<LesPortesEnRe />} />
                <Route path="/plages-ile-de-re" element={<PlagesIleDeRe />} />
                <Route path="/activites-ile-de-re" element={<ActivitesIleDeRe />} />
                <Route path="/location-villa-luxe-ile-de-re" element={<LocationVillaLuxe />} />
                <Route path="/vacances-famille-ile-de-re" element={<VacancesFamille />} />
                <Route path="/golf-ile-de-re" element={<GolfIleDeRe />} />
                <Route path="/que-faire-ile-de-re" element={<QueFaireIleDeRe />} />
                <Route path="/weekend-ile-de-re" element={<WeekendIleDeRe />} />
                <Route path="/moyenne-saison-ile-de-re" element={<MoyenneSaison />} />
                <Route path="/seminaire-ile-de-re" element={<SeminaireIleDeRe />} />
              </Routes>
              <Footer />
              <ChatWidget />
            </>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;